// extracted by mini-css-extract-plugin
export default {"createBuyOfferInput":"NCm_obGak2sLOWMGwUq7","createBuyOfferAvailableXlm":"l8sDS1Ld8YGhQ_TFynqo"};